import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { get } from "lodash";
import { useSocketEvent } from "@/hooks/worklist-socket";
import { applySmsStatusEvent } from "@/utils/sms";
/**
 * Subscribes to `sms_status` worklist-socket events and patches the matching
 * cached SMS history in place, so open History views update live without polling.
 */
export function useSmsStatusEvents() {
  var queryClient = useQueryClient();
  var handleStatus = useCallback(function (message) {
    var event = get(message, ["content"], null);
    if (event) applySmsStatusEvent(queryClient, event);
  }, [queryClient]);
  useSocketEvent("sms_status", handleStatus);
}